const btn = {
  label: 'Ver Más Equipos',
  Typography: 'No se ha encontrado ningún equipo para este lugar'
}

export default btn;
